export default __webpack_public_path__ + "static/media/IndiraChowdhury.076c3793.png";